import axios from 'axios'
import { arrayToQueryString } from '@utils/url'
export const state = {
  eventList: [],
}

export const getters = {}

export const mutations = {
  CACHE_EVENT_LIST(state, newList) {
    state.eventList = newList
  },
}

export const actions = {
  fetchEventList({ commit, state, rootState }, { filter }) {
    return axios
      .get(
        `${process.env.VUE_APP_API_BASE_URL}/event/list?${arrayToQueryString(
          filter
        )}`
      )
      .then((response) => {
        const list = response.data
        commit('CACHE_EVENT_LIST', list)
        return list
      })
  },
  addEvent({ commit, state, rootState }, { eventData }) {
    return axios
      .post(`${process.env.VUE_APP_API_BASE_URL}/event`, eventData)
      .then((response) => {
        const event = response.data
        return event
      })
  },
  updateEvent({ commit, state, rootState }, { eventData }) {
    return axios
      .patch(
        `${process.env.VUE_APP_API_BASE_URL}/event/${eventData.id}`,
        eventData
      )
      .then((response) => {
        const event = response.data
        return event
      })
  },
  deleteEvent({ commit, state, rootState }, { Data }) {
    return axios
      .delete(`${process.env.VUE_APP_API_BASE_URL}/event/${Data.id}`)
      .then((response) => {
        const data = response.data
        return data
      })
  },
  getSignedImage({ commit, state, rootState }, data) {
    return axios
      .get(`${process.env.VUE_APP_API_BASE_URL}/imageurl?image=${data}`)
      .then((response) => {
        const data = response.data
        return data
      })
  },
}
